// Import all the icons which need to be used in campaigns where the icon name is coming from iris campaign config
import 'mini-fluent-svg-icons/lib/icons/SettingsRegular';
